module.exports = __webpack_public_path__ + "media/images/HowItWorksRight-ff1332ad34d758ec0f24af90d4525b90.svg";